/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

// import { Customer } from "App/Models";
import { AdsPublications, AdsPublicationsApi, SetupGateway } from "App/IOC/Services";


import Columns from "./Columns";
import Fields from "./Fields";
import Filters from "./Filters";
import PlaceholderData from "./PlaceholderData";

export default {
    Columns,
    Filters,
    Fields,
    PlaceholderData,
    Create: AdsPublications.Create,
    Update: AdsPublications.Update,
    Get: AdsPublications.Get,
    Find: AdsPublications.Find,
    GetAllCustomers: AdsPublications.GetAllCustomers,
    GetCustomerEnrichment: AdsPublications.GetCustomerEnrichment,
    CustomerCreate: AdsPublications.CustomerCreate,
    DeleteCustomer: AdsPublications.DeleteCustomer,
    DeleteGateWay: AdsPublications.DeleteGateWay,
    DeletePicture: AdsPublications.DeletePicture,
    GetAllSerializers: AdsPublications.GetAllSerializers,

    /* API-type gateways (Amanda). Same contract as the FTP methods above, routed to /gateway-api/*
       through the API-bound service instance. */
    CreateApi: AdsPublicationsApi.Create,
    UpdateApi: AdsPublicationsApi.Update,
    GetApi: AdsPublicationsApi.Get,

    /* Per-user gateway setups for a portal (Amanda). List/get/update/delete scoped by groupId,
       create scoped by the target user_id. */
    SetupList: SetupGateway.ListByGroup,
    SetupGet: SetupGateway.Get,
    SetupCreate: SetupGateway.Create,
    SetupUpdate: SetupGateway.Update,
    SetupDelete: SetupGateway.Remove
};
